<template>
    <div v-html="sanitizedContent">
    </div>
</template>

<script>
    import DOMPurify from 'dompurify';

    export default {
        name: 'SanitizedHtml',
        props: {
            content: {
                type: String,
                required: true
            },
        },
        computed: {
            sanitizedContent() {
                return this.clearDOM(`${this.content}`);
            }
        },
        methods: {
            clearDOM(content) {
                return DOMPurify.sanitize(content, { FORBID_TAGS: ['style'] });
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/components/SanitizedHtml.vue